import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { Typography, Space } from "antd";

const { Text } = Typography;

export function CompletionDonutChart({ data, filters }) {
  let filteredTasks = data.todasLasTareas;

  if (filters.proyecto) {
    filteredTasks = filteredTasks.filter((t) => t.proyectoCodigo === filters.proyecto);
  }
  if (filters.fase) {
    filteredTasks = filteredTasks.filter((t) => t.fase === filters.fase);
  }

  const completado = filteredTasks.filter((t) => t.estado === "completado").length;
  const enProgreso = filteredTasks.filter((t) => t.estado === "en-progreso").length;
  const enRiesgo = filteredTasks.filter((t) => t.estado === "en-riesgo").length;
  const atrasado = filteredTasks.filter((t) => t.estado === "atrasado").length;

  const total = filteredTasks.length || 1;

  const chartData = [
    { name: "Completado", value: completado, color: "#009728" },
    { name: "En Progreso", value: enProgreso, color: "#317EDA" },
    { name: "En Riesgo", value: enRiesgo, color: "#FFA500" },
    { name: "Atrasado", value: atrasado, color: "#D72638" },
  ];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const info = payload[0];
      const porcentaje = ((info.value / total) * 100).toFixed(1);
      return (
        <div
          style={{
            background: "#fff",
            border: "1px solid #d9d9d9",
            borderRadius: 8,
            padding: 10,
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          }}
        >
          <Text strong style={{ color: info.payload.color }}>
            {info.name}
          </Text>
          <br />
          <Text>{info.value} tareas</Text>
          <br />
          <Text type="secondary">{porcentaje}%</Text>
        </div>
      );
    }
    return null;
  };

  return (
    <div>
      <div style={{ width: "100%", height: 320, marginTop: 16 }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Tooltip content={<CustomTooltip />} />
            <Legend
              layout="horizontal"
              verticalAlign="bottom"
              align="center"
              iconType="circle"
              wrapperStyle={{
                marginTop: 16,
                display: "flex",
                justifyContent: "center",
                flexDirection: "row",
                gap: "20px",
                fontSize: 13,
                flexWrap: "wrap",
              }}
              formatter={(value) => (
                <span style={{ color: "#444", fontWeight: 500 }}>{value}</span>
              )}
            />
            <Pie
              data={chartData}
              cx="50%"
              cy="45%"
              innerRadius={60}
              outerRadius={100}
              dataKey="value"
              paddingAngle={3}
              labelLine={false}
            >
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>

      <Space
        direction="horizontal"
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: 12,
          flexWrap: "wrap",
          gap: 12,
        }}
      >
        <Text strong style={{ color: "#009728" }}>
          {completado} Completadas
        </Text>
        <Text strong style={{ color: "#317EDA" }}>
          {enProgreso} En progreso
        </Text>
        <Text strong style={{ color: "#FFA500" }}>
          {enRiesgo} En riesgo
        </Text>
        <Text strong style={{ color: "#D72638" }}>
          {atrasado} Atrasadas
        </Text>
      </Space>
    </div>
  );
}
